document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;
  const menuInTopElement = document.getElementById('home-menu-treshold');

  if (
    (body.classList.contains('index') ||
      body.classList.contains('page-pasion-cta') ||
      body.classList.contains('page-pasion-2026-v2') ||
      body.classList.contains('page-equilibrio-cta') ||
      body.classList.contains('page-laspizarras')  ||
      body.classList.contains('page-mariluna') ||
      body.classList.contains('page-new'))    &&
    menuInTopElement
  ) {
    function checkScrollPosition() {
      const elementRect = menuInTopElement.getBoundingClientRect();
      const elementTop = elementRect.top + window.scrollY;
      const currentScroll = window.scrollY;
      const headerDrawerOther = document.querySelector('header-drawer');
      const headerIcons = document.querySelector('.header__icons');

      if (currentScroll >= elementTop) {
        body.classList.add('menu-in-top');
        headerDrawerOther.style.visibility = 'visible';
        // This works on load, but not on resize
        if (window.innerWidth < 990) {
          headerIcons.style.visibility = 'visible';
        }
      } else {
        body.classList.remove('menu-in-top');
        headerDrawerOther.style.visibility = 'hidden';
        // This works on load, but not on resize
        if (window.innerWidth < 990) {
          headerIcons.style.visibility = 'hidden';
        }
      }
    }

    checkScrollPosition();

    window.addEventListener('scroll', checkScrollPosition);
  }
});
